import { Breadcrumbs, Link } from "@mui/material";
import Container from "components/container";
import FileViewButton from "components/file-view-button";
import Layout from "components/layout";
import { RichTextContainer } from "components/rich-text-container";
import SafeHtml from "components/safe-html";
import { useDictionary } from "hooks/use-dictionary";
import { useGetInformationalContentPage } from "hooks/api/use-get-informational-content-page";
import SectionTitle from "./home/components/section-title";
import { StaticContentPageEnum } from "types/static-content";

export const SpecialistAttractionProject = () => {
  const dict = useDictionary();
  const { data: page, isLoading } = useGetInformationalContentPage(StaticContentPageEnum.SPECIALIST_ATTRACTION_PROJECT);

  if (isLoading) {
    return null;
  }

  if (!page?.content) {
    throw new Error("Specialist attraction project content is missing");
  }

  const attachmentFiles = page.files?.filter((file) => !file.url || !page.content.includes(file.url)) ?? [];

  return (
    <Layout>
      <div className="space-y-8 py-12">
        <Container className="bg-theme-background" childClassName="space-y-4">
          <Breadcrumbs>
            <Link href="/">{dict.common.breadcrumbsRoot}</Link>
            <div>{dict.specialistAttractionProject.title}</div>
          </Breadcrumbs>
          <RichTextContainer>
            <div className="space-y-5">
              <SectionTitle>{dict.specialistAttractionProject.title}</SectionTitle>
              <div className="bg-white border rounded p-5 space-y-5">
                <div className="space-y-2">
                  <div className="content-block [&_p]:mt-3">
                    <SafeHtml html={page.content} />
                  </div>
                </div>
                {attachmentFiles.length > 0 && (
                  <div className="space-y-2">
                    <div className="font-bold mb-2">{dict.news.documents}</div>
                    <div className="space-y-3">
                      {attachmentFiles.map((file) => (
                        <FileViewButton file={file} key={file.fileName} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </RichTextContainer>
        </Container>
      </div>
    </Layout>
  );
};
